import { Injectable } from '@angular/core';
import { getApiUrl } from 'src/environments/helpers';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../../../environments/environment';
import { AppNotificationService } from 'src/app/shared/services/app-notification/app-notification.service';

declare var $: any;
declare var DevExpress: any;
@Injectable({
  providedIn: 'root',
})
export class AdminLayoutService {
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  private API_URL: string;
  init = false;

  constructor(
    private http: HttpClient,
    private notify: AppNotificationService
  ) {
    this.API_URL = getApiUrl();
  }

  play() {
    var audio = new Audio('../../../../../assets/audio/notification.mp3');
    window.focus();
    audio.play();
  }

  connectSignalR() {
    if (!this.init) this.init = true;
    else return;
    const connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(environment.baseUrl + '/messageHub', {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => {
        connection
          .invoke('Connection', this.currentUser.id)
          .catch(function (err) {
            return console.error(err.toString());
          });
      })
      .catch(function (err) {
        return console.error(err.toString());
      });

    var start = () => {
      try {
        console.log('restart');
        connection
          .start()
          .then(() => {
            connection
              .invoke('Connection', this.currentUser.id)
              .catch(function (err) {
                return console.error(err.toString());
              });
          })
          .catch(function (err) {
            return console.error(err.toString());
          });
      } catch (err) {
        console.log(err);
        setTimeout(start, 1000);
      }
    };

    connection.onclose(start);

    connection.onreconnected((connId) => {
      console.log('reconnected');
      connection
        .invoke('Connection', this.currentUser.id)
        .catch(function (err) {
          return console.error(err.toString());
        });
    });

    connection.on('SendMessageToClient', (message, idNotification) => {
      DevExpress.ui.notify(message, 'success', 1000);
    });

    connection.on('SendReminderToClient', (OrderId, Note, Id) => {
      this.play();
      this.notify.notification({
        title: 'Hẹn gọi lại',
        message: `${Note || 'Nội dung trống'} `,
        action: { idOrder: OrderId, idReminder: Id },
      });
    });

    connection.on(
      'SendMessageToClientByToast',
      (title, message, idNotification) => {
        this.play();
        this.notify.notification({
          title: title,
          message: `${message} `,
          action: { idNotification: idNotification },
        });
      }
    );

    connection.on(
      'SendMessageToClientByToastRedirectOrderMobile',
      (title, message, idOrder, idNotification) => {
        this.play();
        this.notify.notification({
          title: title,
          message: `${message}`,
          type: 'dup',
          action: { idOrder: idOrder, idNotification: idNotification },
        });
      }
    );
    connection.on(
      'SendMessageToClientByToastRedirectOrderId',
      (title, message, idOrder, idNotification) => {
        this.play();
        this.notify.notification({
          title: title,
          message: `${message}`,
          action: { idOrder: idOrder, idNotification: idNotification },
        });
      }
    );

    connection.on('SendProgressToClient', (message, progress, count) => {
      if (progress < count) {
        $('#main-progress-bar').text(
          message + ':' + progress + '/' + count + '...'
        );
        $('#main-progress-bar').show();
      } else {
        $('#main-progress-bar').hide();
      }
    });
  }

  getSource() {
    return this.http
      .get(`${this.API_URL}/${this.currentUser.domain}/Level/`)
      .subscribe(
        (res) => {},
        (err) => {
          debugger;
          // if(err.status == 401){
          //   localStorage.removeItem('currentUser');
          //   window.location.reload();
          // }
        }
      );
  }

  GetDefaultFilter(){
    return this.http.post(`${this.API_URL}/emg/Group/GetDefaultFilter`, [])
  }
}
